import { KeyDict, Loader, Result } from 'kiswe-ui'
import { FanRoomScheduleRow } from './FanRoomScheduleRow'

export class FanRoomSchedule {
  active: boolean
  deleted: boolean
  disciplines: KeyDict<FanRoomScheduleRow> = {}
  name: string
  teamId: string

  constructor (data: unknown) {
    this.active = Loader.loadBoolean(data, 'active')
    this.deleted = Loader.loadBoolean(data, 'deleted')
    // Dict of disciplines(/categories) where each discipline is a dict of time range objects. The keys of the latter
    // dict act as the label for the time range.
    this.disciplines = Loader.loadKeyDict(data, 'disciplines', (discipline) => new FanRoomScheduleRow(discipline))
    this.name = Loader.loadString(data, 'name')
    this.teamId = Loader.loadString(data, 'teamId')
  }

  get sortedDisciplines (): KeyDict<FanRoomScheduleRow> {
    return Object.fromEntries(
      Object.entries(this.disciplines).sort(([disciplineIdA, disciplineA], [disciplineIdB, disciplineB]) =>
        (disciplineA.name ?? disciplineIdA).localeCompare(disciplineB.name ?? disciplineIdB)
      )
    )
  }

  static load (data: unknown): Result<FanRoomSchedule, 'invalid_params'|'unknown'> {
    try {
      return Result.success(new FanRoomSchedule(data))
    } catch (error) {
      return Result.fromUnknownError('invalid_params', error)
    }
  }
}
